import React from "react";
import { connectRefinementList } from "react-instantsearch/connectors";
import { withRouter } from "react-router-dom";
import LeadingText from "../LeadingText";
import SupportingText from "../SupportingText";
import CollectionSearchDraw from "../Icons/CollectionSearchDraw";
import FilterDraw from "../Icons/FilterDraw";
import ArrowRight from "../Icons/ArrowRight";
import ArrowLeft from "../Icons/ArrowLeft";
import FloatingActionButton from "../FloatingActionButton";
import CollectionList from "../CollectionList";
import CollectionListItem from "../CollectionListItem";
import FullScreenOverlay from "../FullScreenOverlay";

import CollectionImages from "../images/LB-Design.jpg";
import LibudaLogo from "../images/Libuda-Logo.svg";

const DisplayBrands = [
  { logoName: "Destijl", labelName: "De Stijl 1924" },
  { logoName: "Evatik", labelName: "Evatik" },
  { logoName: "Fysh", labelName: "Fysh UK" },
  { logoName: "Kama", labelName: "Kamasutra Eyewear" },
  { logoName: "Youpi", labelName: "Youpi!" },
  { logoName: "Superflex", labelName: "Superflex Titan" },
  { logoName: "LBDesign", labelName: "LB-Design" }
];

const BrandLogos = {};
DisplayBrands.forEach(b => {
  /* eslint-disable-next-line global-require, import/no-dynamic-require */
  BrandLogos[b.logoName] = require(`../images/${b.logoName}.svg`);
});

export const IntroHeader = ({ title, subtitle }) => {
  return (
    <div className="py-8  px-8">
      {/* <LeadingText textSize="2xl" textColor="blue-darker">
        {title}
      </LeadingText> */}
      {/* <div className="mt-3">
        <SupportingText textColor="blue-darker" inline>
          {subtitle}
        </SupportingText>
      </div> */}
      <div className="w-full flex items-center justify-center">
        <img style={{ maxHeight: "64px" }} src={LibudaLogo} />
      </div>
    </div>
  );
};

export const IntroCard = ({
  header,
  description,
  call,
  skewDirection,
  flip,
  icon: Icon,
  onIconClick
}) => {
  return (
    <div className="w-full bg-white shadow-blur-md flex flex-no-wrap items-stretch rounded overflow-hidden">
      <div
        style={{
          transform: `skewX(${skewDirection === "-" ? "-" : ""}12deg)`,
          order: flip ? `1` : `2`
        }}
        className="w-1/2 bg-grey-lighter relative"
      >
        <div
          style={{
            transform: `skewX(${skewDirection === "-" ? "" : "-"}12deg)`
          }}
          className="absolute pin-t pin-l w-full h-full flex flex-col items-center justify-center"
        >
          <div
            style={{ zIndex: -1 }}
            className={`w-1/2 h-full absolute bg-grey-lighter pin-${
              flip ? "l" : "r"
            }`}
          />
          <Icon width="80%" height="80%" />
        </div>
      </div>
      <div
        style={{
          order: flip ? `2` : `1`
        }}
        className={`flex flex-col items-${
          flip ? "end" : "start"
        } w-1/2 bg-white py-4 px-4`}
      >
        <LeadingText textSize="" textColor="teal">
          {header}
        </LeadingText>
        <div className="mt-3 w-full">
          <SupportingText
            style={{ width: "100%" }}
            textAlign={flip ? "right" : "left"}
          >
            {description}
          </SupportingText>
        </div>
        <div className="flex items-center justify-center mt-4">
          <SupportingText
            textSize="base"
            fontWeight="medium"
            style={{
              order: flip ? `1` : `2`,
              [`margin${flip ? "Right" : "Left"}`]: "5px"
            }}
            textColor="blue-darker"
          >
            {call}
          </SupportingText>
          <FloatingActionButton
            onClick={onIconClick}
            bgColor="blue-darker"
            size="xs"
            inlineStyle={{
              order: flip ? `2` : `1`
            }}
          >
            {flip ? (
              <ArrowRight width="20" height="20" stroke="white" />
            ) : (
              <ArrowLeft width="20" height="20" stroke="white" />
            )}
          </FloatingActionButton>
        </div>
      </div>
    </div>
  );
};

const GradientOverlay = () => {
  return (
    <div
      style={{
        height: "60px",
        background:
          "linear-gradient(to top, white 0%, rgba(255, 255, 255, 0) 100%)"
      }}
      className="absolute pin-b pin-l w-full"
    />
  );
};

const refineCollection = (name, props, redirect = "/article") => () => {
  if (props.canRefine) {
    const refinedItem = props.items.find(i => i.label === name);

    if (refinedItem && refinedItem.value) {
      props.refine(refinedItem.value);
    }
    props.history.push(redirect);
  }
};

const CollectionListBrandImage = ({ src }) => {
  return (
    <img
      style={{ height: "64px", maxHeight: "64px" }}
      className="w-1/2"
      src={src}
    />
  );
};

const Collection = props => {
  return (
    <div className="relative border border-grey-light rounded">
      <GradientOverlay />
      <CollectionList height="75vh">
        {DisplayBrands.map(brand => {
          return (
            <CollectionListItem
              key={brand.logoName}
              onClick={refineCollection(brand.labelName, props)}
            >
              <CollectionListBrandImage src={BrandLogos[brand.logoName]} />
            </CollectionListItem>
          );
        })}
        <div className="mb-3" />
      </CollectionList>
    </div>
  );
};

const ConnectedCollection = connectRefinementList(withRouter(Collection));

const CollectionHeader = ({ onBackClick }) => {
  return (
    <div className="w-full flex items-center justify-between py-3">
      <FloatingActionButton
        onClick={onBackClick}
        bgColor="blue-darker"
        size="xs"
      >
        <ArrowLeft width="22" height="15" stroke="white" />
      </FloatingActionButton>
      <LeadingText fontWeight="lg" textColor="grey-darkest">
        Unsere Kollektionen
      </LeadingText>
      <div />
    </div>
  );
};

class Intro extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showOverlay: false
    };
  }

  onCollectionClick = () => {
    const { onResetSearchState } = this.props;
    this.setState(
      {
        showOverlay: true
      },
      onResetSearchState
    );
  };

  /* eslint-disable-next-line class-methods-use-this */
  render() {
    const { history } = this.props;
    return (
      <div style={{ zIndex: 2 }} className="w-full h-full px-3 relative">
        <IntroHeader
          title="Die Libuda Optic World - APP 2.0"
          subtitle="In unserer App können Sie einfach und jederzeit alle unsere Kollektionen erleben."
        />
        <div className="px-3 sm:py-3">
          <div className="w-full mb-3">
            <IntroCard
              header="Kollektionen"
              icon={CollectionSearchDraw}
              description="Erleben Sie alle unsere Kollektionen."
              call="Ansehen"
              skewDirection="-"
              flip
              onIconClick={this.onCollectionClick}
            />
          </div>
          <div className="w-full mb-3">
            <IntroCard
              header="Filter"
              icon={FilterDraw}
              description="Finden Sie direkt Ihren Artikel."
              call="Suchen"
              skewDirection="+"
              onIconClick={() => history.push("/filter")}
            />
          </div>
        </div>
        <FullScreenOverlay
          axis="x"
          startingPosition="positive"
          show={this.state.showOverlay}
        >
          <div className="w-full h-full flex flex-col items-center px-3">
            <CollectionHeader
              onBackClick={() =>
                this.setState({
                  showOverlay: false
                })
              }
            />
            <ConnectedCollection attribute="brand" limit={20} />
          </div>
        </FullScreenOverlay>
        <div
          style={{
            // background: "rgba(255, 255, 255, 0.6)",
            zIndex: -1
          }}
          className="w-full h-full absolute pin-t pin-l"
        />
        <div
          className="w-full h-full absolute pin-t pin-l"
          style={{
            zIndex: -2,
            background: `url(${CollectionImages})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center -25%",
            opacity: ".8",
            filter: "blur(6px)"
          }}
        />
      </div>
    );
  }
}

export default withRouter(Intro);



// WEBPACK FOOTER //
// ./src/Intro/Intro.js